module.exports = __webpack_public_path__ + "img/cxtck2@2x.6c2c03c7.png";